/** 24px inset (`--sp-6`) for header, body, footer, and scroll regions in artifact canvases. */
export const artifactCanvasSectionPaddingClass = 'p-6'
